var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21C17.5 21.9283 17.8687 22.8185 18.5251 23.4749C19.1815 24.1313 20.0717 24.5 21 24.5C21.9283 24.5 22.8185 24.1313 23.4749 23.4749C24.1313 22.8185 24.5 21.9283 24.5 21C24.5 20.0717 24.1313 19.1815 23.4749 18.5251C22.8185 17.8687 21.9283 17.5 21 17.5C20.0717 17.5 19.1815 17.8687 18.5251 18.5251C17.8687 19.1815 17.5 20.0717 17.5 21Z",
    stroke: "#010CA6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 21C32.55 28 27.3 31.5 21 31.5C14.7 31.5 9.45 28 5.25 21C9.45 14 14.7 10.5 21 10.5C27.3 10.5 32.55 14 36.75 21Z",
    stroke: "#010CA6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.51bfd04a73c76f72bb334d80b4977618.svg";
export { ForwardRef as ReactComponent };